import React from 'react'
import { useHistory } from 'react-router-dom'
import { t } from '@lingui/macro'
import { Button, NextIcon } from 'pages/native/onBoarding/components'
import {
  useCompanyName,
  useFollowedTeams
} from 'pages/native/onBoarding/context/OnBoardingContext'
import {
  NATIVE_PUBLIC_ROUTES,
  nativePublicPathGenerator
} from 'routes/native/PublicRoutes'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './NextButton.module.scss'

export const NextButton = () => {
  const history = useHistory()
  const { value: company } = useCompanyName()
  const { value: followedTeams } = useFollowedTeams()
  const { trackGtm, trackClarity } = useAnalytics()

  const handleNextClick = () => {
    const selectedTeamIds = followedTeams.map((team) => team.id)

    trackGtm('follow_team_continue_clicked_app', {
      selected_teams: selectedTeamIds,
      selected_teams_count: selectedTeamIds.length
    })

    trackClarity('follow_team_continue_clicked_app', {
      selected_teams: selectedTeamIds,
      selected_teams_count: selectedTeamIds.length
    })

    history.push(
      nativePublicPathGenerator(
        NATIVE_PUBLIC_ROUTES.AUTH.SIGN_UP,
        company
      )
    )
  }
  return (
    <div className={styles.NextButtonWrapper}>
      <Button
        label={t`Next`}
        icon={<NextIcon />}
        iconPosition="right"
        variant="filled"
        theme="primary"
        disabled={followedTeams.length === 0}
        onClick={handleNextClick}
      />
    </div>
  )
}
